<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16.444" height="16.446" viewBox="0 0 16.444 16.446">
        <g id="Icon-Link" transform="translate(-249.468 -333.797)">
            <path 
            id="Path_435" 
            data-name="Path 435" 
            d="M252.073,350.075a3.614,3.614,0,0,1-1.539-.951,3.668,3.668,0,0,1-1.065-2.636,4.055,4.055,0,0,1,.5-2c.238-.461.54-.795,2.361-2.617,2.232-2.232,2.491-2.433,3.541-2.743a4.907,4.907,0,0,1,2.159,0,2.962,2.962,0,0,1,1.862,1.341,1.023,1.023,0,0,1-1.659,1.079,1.638,1.638,0,0,0-1.282-.485c-.869,0-1.017.106-3.137,2.222a13.883,13.883,0,0,0-2.078,2.275,1.746,1.746,0,0,0,1.531,2.634c.734,0,1.1-.229,2.337-1.438l1.049-1.025.377.173a3.629,3.629,0,0,0,1.794.257l.358-.067-1.711,1.689c-1.838,1.815-2.221,2.1-3.2,2.351a4.363,4.363,0,0,1-2.192-.055Zm5.918-5.046a3.189,3.189,0,0,1-2.5-1.453,1.036,1.036,0,0,1,1.145-1.339,2.079,2.079,0,0,1,.634.341,1.85,1.85,0,0,0,2.067.216,31.7,31.7,0,0,0,4.289-4.271,1.767,1.767,0,0,0-.145-2.043,1.6,1.6,0,0,0-1.363-.629c-.734,0-1.1.228-2.337,1.438l-1.051,1.025-.375-.173a3.626,3.626,0,0,0-1.793-.257l-.357.067,1.71-1.69a10.5,10.5,0,0,1,2.237-1.963,4.033,4.033,0,0,1,2.01-.5,3.748,3.748,0,0,1,3.632,2.748,4.713,4.713,0,0,1,0,2.047,5.716,5.716,0,0,1-.385.965c-.238.459-.541.8-2.361,2.615-2.155,2.155-2.393,2.346-3.33,2.681a4.689,4.689,0,0,1-1.736.174Z" 
            transform="translate(0 0)" 
            class="a"
            :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'"
            />
        </g>
    </svg>
</template>

<script>
export default {
  name: 'LinkIcon'
}
</script>

<style scoped>
    svg {
        width:16.444px;
        height: 16.446px;
    }
</style>